export class TipoEstablecimiento {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
